import { useMemo } from 'react';

const SectionParticles = () => {
  const stars = useMemo(() => {
    const result = [];
    for (let i = 0; i < 48; i++) {
      const gold = Math.random() < 0.3;
      result.push({
        id: i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: 1 + Math.random() * 2,
        gold,
        opacity: 0.15 + Math.random() * 0.45,
        duration: 3 + Math.random() * 5,
        delay: Math.random() * 6,
      });
    }
    return result;
  }, []);

  return (
    <div
      className="absolute inset-0 overflow-hidden pointer-events-none z-0"
      aria-hidden="true"
      data-testid="section-particles"
    >
      <div
        className="absolute rounded-full blur-[110px]"
        style={{
          width: 460,
          height: 460,
          top: '15%',
          right: '-8%',
          background: 'radial-gradient(circle, rgba(74,144,226,0.09) 0%, transparent 70%)',
        }}
      />
      <div
        className="absolute rounded-full blur-[110px]"
        style={{
          width: 380,
          height: 380,
          bottom: '10%',
          left: '-6%',
          background: 'radial-gradient(circle, rgba(201,162,39,0.05) 0%, transparent 70%)',
        }}
      />
      {stars.map((s) => (
        <span
          key={s.id}
          className="star-particle absolute rounded-full"
          style={{
            left: `${s.left}%`,
            top: `${s.top}%`,
            width: s.size,
            height: s.size,
            background: s.gold ? '#c9a227' : '#ffffff',
            boxShadow: s.gold ? '0 0 6px rgba(201,162,39,0.7)' : '0 0 4px rgba(255,255,255,0.5)',
            '--o': s.opacity,
            animationDuration: `${s.duration}s`,
            animationDelay: `${s.delay}s`,
          }}
        />
      ))}
    </div>
  );
};

export default SectionParticles;
